

































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";

@Component({
  name: 'LabelTranshipmentPrint'
})
export default class extends mixins(CommonMixin) {
  @Prop({required: true, type: Number}) readonly id!: number;
  get pickingListTranshipment() {
    return PickingListTranshipmentStore.data[this.id];
  }
}
